import React from 'react';
import classes from './Label2.css';

const label2 = (props) => {

    let labelDivClass = classes.LabelDivVertical;
    if(props.displayType && props.displayType==='horizontal') {
        labelDivClass = classes.LabelDivHorizontal
    }

    let labelTextElem = classes.LabelElement;

    let labelValueElem = classes.LabelElement;

    const labelAlign = props.labelAlign?props.labelAlign:"left";

    if(props.labelValueWidth) {
        labelValueElem.style();
    }

    return(
        <div className={labelDivClass}>
            <div className={labelTextElem} style={{width: props.labelWidth, textAlign: labelAlign}}>
                <label className={classes.LabelText}>{props.labelText}</label>
            </div>
            <div className={labelValueElem}>
                <label className={classes.LabelValue}> {props.labelValue}</label>
            </div>
        </div>
    );
}

export default label2;